<template>
  <div
    class="tw:mx-auto tw:max-w-sm tw:py-4 tw:px-6 shadow tw:bg-white tw:border-t-8 tw:border-solid tw:border-red-700 tw:rounded-lg"
  >
    <h4 class="tw:py-4 tw:text-2xl">
      {{ $t('admin_error_message_header') }}
    </h4>
    <p class="tw:text-md tw:pb-4" v-html="$t('admin_error_message_text')" />
    <MainButton class="tw:w-full" @click.prevent="redirectToHome">
      {{ $t('appStore.emptyState.backButton') }}
    </MainButton>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import MainButton from '@/components/base/buttons/MainButton.vue'

const router = useRouter()

/**
 * Redirect user back to home page
 */
const redirectToHome = (): void => {
  router.push({ name: 'home' })
}
</script>
